import { Grid } from "@material-ui/core";
import MaterialTable from "material-table";
import React from "react";
import { cellS, headerS } from "../../../../St/comps/cStyle";
import { useTranslation } from "react-i18next";

import { useStylesContainers } from "../../../../St/comps/UseStyle";
function getItemFromOptions(id, options) {
  if (id) return options.filter((g) => g.id == id)[0];
  return "";
}
function GetEmpFromOptions(id, options) {
  const index = options?.findIndex((op) => op.id == id);
  return options[index];
}
const UserTable = (props) => {
  const { users, onShow,AutoOptions } = props;
  const { t } = useTranslation(["forms"]);
  const clsConts = useStylesContainers();
  const columns = [
    { title: t("number"), field: "id" },
    { title: t("employee"), field: "emp" },
    { title: t("user"), field: "name" },
    { title: t("password"), field: "password" },
    { title: t("branch"), field: "branch" },
    { title: t("safe"), field: "safe" },
    { title: t("stock"), field: "stock" },
  ];

  function onRowClickHandle(data) {
    onShow(
      {
        ...data,
        User_type: data?.Usertype,
        safe: getItemFromOptions(data.safe, data.SafeEmp),
        stock: getItemFromOptions(data.stock, data.StockEmp),
        nPassword: data.password,
        nName: data.name,
        center: GetEmpFromOptions(data.center, AutoOptions.center),
        salesmen: GetEmpFromOptions(data.salesmen, AutoOptions.salesmen)

      },
      "edit"
    );
  }
  return (
    <Grid item container lg={12} md={12} className={[clsConts.rootdown]}>
      <Grid
        item
        container
        xs={12}
        className={[clsConts.subDown, clsConts.subDownC]}
      >
        <Grid item xs={12}>
          <MaterialTable
            style={{ boxShadow: "none" }}
            title=""
            // variant="outlined"
            options={{
              pageSize: 7,
              //showTitle:false,
              toolbar: false,
              sorting: false,
              showTitle: false,
              paging: false,

              headerStyle: { ...headerS, backgroundColor: "#20369f" },
              cellStyle: cellS,
              maxBodyHeight: "65vh",
              minBodyHeight: "65vh",
            }}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h3
                    style={{
                      marginTop: "20vh",
                      border: "solid 0px",
                      boxShadow: "none",
                    }}
                  ></h3>
                ),
              },
            }}
            columns={columns}
            data={users}
            onRowClick={(event, rowData) => {
              onRowClickHandle(rowData);
              // event.stopPropagation();
              event.preventDefault();
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default UserTable;
